import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { NotificationCenterService } from './notification-center';
import { FormsModule } from '@angular/forms';
import { CommonUiModule, CustomTemplateDirective, TabsModule } from '@tablesready/common-ui';
import { BadgeModule } from '@tablesready/frontend-badge';
import { NotificationCenterSidebarComponent } from './notification-center/notification-center-sidebar.component';
import { FrontendChatPartyComponent } from '@tablesready/frontend-chat-party';

@NgModule({
  declarations: [NotificationCenterSidebarComponent],
  imports: [
    IonicModule,
    CommonModule,
    FormsModule,
    CommonUiModule,
    TabsModule,
    CustomTemplateDirective,
    FrontendChatPartyComponent,
    BadgeModule,
  ],
  providers: [NotificationCenterService],
  exports: [NotificationCenterSidebarComponent],
})
export class NotificationCenterModule {}
